import React from "react";
import O1 from "../../Images/New/Ofm/1.png"
import O2 from "../../Images/New/Ofm/2.png"
import O3 from "../../Images/New/Ofm/3.png"
import O4 from "../../Images/New/Ofm/4.png"
import O5 from "../../Images/New/Ofm/5.png"
import O6 from "../../Images/New/Ofm/6.png"
import O7 from "../../Images/New/Ofm/7.png"
import O8 from "../../Images/New/Ofm/8.png"

const Ofm = () => {
  return (
    <>
      <div className="relative bg-[#f1f5f9] px-5 py-20 flex flex-col items-center justify-center ">
        <div className="block sm:hidden mb-5">
          <p className=" text-center text-3xl sm:text-3xl font-bold text-black">
            Office Management <br />
            Utilities
          </p>
        </div>
        <div className="sm:grid hidden grid-cols-3 items-center justify-center max-w-7xl sm:px-8">
          <div className="flex flex-col space-y-3 items-start sm:items-end">
            <div className="flex flex-row-reverse sm:flex-row items-center justify-end">
              <div className="text-center sm:text-left">
                <p className="bg-white w-full sm:w-[300px] py-2 text-2xl font-semibold shadow-xl text-black px-7 m-0">
                  My Desk
                </p>
              </div>
              <img src={O1} alt="" className="w-[11%]" />
            </div>
            <div className="flex flex-row-reverse sm:flex-row items-center  justify-end">
              <div className="text-center sm:text-left">
                <p className="bg-white w-full sm:w-[300px] py-2 text-2xl font-semibold shadow-xl text-black px-7 m-0">
                  My Invoice
                </p>
              </div>
              <img src={O2} alt="" className="w-[11%]" />
            </div>
            <div className="flex flex-row-reverse sm:flex-row items-center  justify-end">
              <div className="text-center sm:text-left">
                <p className="bg-white w-full sm:w-[300px] py-2 text-2xl font-semibold shadow-xl text-black px-7 m-0">
                  My Documents
                </p>
              </div>
              <img src={O3} alt="" className="w-[11%]" />
            </div>
            <div className="flex flex-row-reverse sm:flex-row items-center  justify-end">
              <div className="text-center sm:text-left">
                <p className="bg-white w-full sm:w-[300px] py-2 text-2xl font-semibold shadow-xl text-black px-7 m-0">
                  Easy Mail
                </p>
              </div>
              <img src={O4} alt="" className="w-[11%]" />
            </div>
          </div>
          <div className="sm:flex bg-white h-full mx-10 rounded-2xl shadow-xl sm:flex-col items-center justify-center hidden">
            {/* <img
              src={OMImage}
              alt="Office_Managment_Image"
              className="w-[97%]"
            /> */}
            <p className=" text-center text-3xl sm:text-3xl font-bold text-black">
              Office Management <br />
              Utilities
            </p>
          </div>
          <div className="mt-3 sm:mt-0 space-y-3">
            <div className="flex items-center">
              <img src={O5} alt="" className="w-[11%]" />
              <div className="w-full text-center sm:text-left">
                <p className="bg-white w-full sm:w-[300px] py-2 text-2xl font-semibold shadow-xl text-black px-7 m-0">
                  Work Book
                </p>
              </div>
            </div>
            <div className="flex items-center">
              <img src={O6} alt="" className="w-[11%]" />
              <div className="w-full text-center sm:text-left">
                <p className="bg-white w-full sm:w-[300px] py-2 text-2xl font-semibold shadow-xl text-black px-7 m-0">
                  Attendance
                </p>
              </div>
            </div>
            <div className="flex items-center">
              <img src={O7} alt="" className="w-[11%]" />
              <div className="w-full text-center sm:text-left">
                <p className="bg-white w-full sm:w-[300px] py-2 text-2xl font-semibold shadow-xl text-black px-7 m-0">
                  Notifications/ Circulars
                </p>
              </div>
            </div>
            <div className="flex items-center">
              <img src={O8} alt="" className="w-[11%]" />
              <div className="w-full text-center sm:text-left">
                <p className="bg-white w-full sm:w-[300px] py-2 text-2xl font-semibold shadow-xl text-black px-7 m-0">
                  Easy Forms
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="block sm:hidden">
          <div className="space-y-2">
            <div className="flex items-center">
              <img src={O1} alt="" className="w-[11%]" />
              <div className="w-full text-center sm:text-left">
                <p className="bg-white w-full sm:w-[300px] py-2 text-2xl font-semibold shadow-xl text-black px-7 m-0">
                  My Desk
                </p>
              </div>
            </div>
            <div className="flex items-center">
              <img src={O2} alt="" className="w-[11%]" />
              <div className="w-full text-center sm:text-left">
                <p className="bg-white w-full sm:w-[300px] py-2 text-2xl font-semibold shadow-xl text-black px-7 m-0">
                  My Invoice
                </p>
              </div>
            </div>
            <div className="flex items-center">
              <img src={O3} alt="" className="w-[11%]" />
              <div className="w-full text-center sm:text-left">
                <p className="bg-white w-full sm:w-[300px] py-2 text-2xl font-semibold shadow-xl text-black px-7 m-0">
                  My Documents
                </p>
              </div>
            </div>
            <div className="flex items-center">
              <img src={O4} alt="" className="w-[11%]" />
              <div className="w-full text-center sm:text-left">
                <p className="bg-white w-full sm:w-[300px] py-2 text-2xl font-semibold shadow-xl text-black px-7 m-0">
                  Easy Mail
                </p>
              </div>
            </div>
            <div className="flex items-center">
              <img src={O5} alt="" className="w-[11%]" />
              <div className="w-full text-center sm:text-left">
                <p className="bg-white w-full sm:w-[300px] py-2 text-2xl font-semibold shadow-xl text-black px-7 m-0">
                  Work Book
                </p>
              </div>
            </div>
            <div className="flex items-center">
              <img src={O6} alt="" className="w-[11%]" />
              <div className="w-full text-center sm:text-left">
                <p className="bg-white w-full sm:w-[300px] py-2 text-2xl font-semibold shadow-xl text-black px-7 m-0">
                  Attendance
                </p>
              </div>
            </div>
            <div className="flex items-center">
              <img src={O7} alt="" className="w-[11%]" />
              <div className="w-full text-center sm:text-left">
                <p className="bg-white w-full sm:w-[300px] py-2 text-2xl font-semibold shadow-xl text-black px-7 m-0">
                  Notifications/ Circulars
                </p>
              </div>
            </div>
            <div className="flex items-center">
              <img src={O8} alt="" className="w-[11%]" />
              <div className="w-full text-center sm:text-left">
                <p className="bg-white w-full sm:w-[300px] py-2 text-2xl font-semibold shadow-xl text-black px-7 m-0">
                  Easy Forms
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Ofm;
